import { UNKNOWN_SPEAKER } from "@app/analytics/MeetingReport/constants";
import {
  ApiSpeakerOperation,
  ApiUpdateTranscriptTurnOperation,
} from "@app/common/types";

export const getApiSpeakerOperation = ({
  turnId,
  action,
  newName,
  existingName,
}: {
  turnId?: string | null;
  action: "replace" | "update" | "untag" | "remove";
  newName: string | null;
  existingName: string;
}): ApiSpeakerOperation | ApiUpdateTranscriptTurnOperation => {
  switch (action) {
    case "update":
      if (!newName || !existingName)
        throw Error("update action must have a newName and existingName");

      return {
        operationKind: "update_speaker",
        name: existingName,
        newName,
      };
    case "replace":
      if (!turnId) throw Error("replace action without turn id");
      if (!newName) throw Error("replace action must have a newName");

      return {
        operationKind: "update_turn",
        turnId,
        speaker: { name: newName },
      };
    case "untag":
      if (!turnId) throw Error("untag action without turn id");

      return {
        operationKind: "update_turn",
        turnId,
        speaker: { name: UNKNOWN_SPEAKER },
      };
    case "remove":
      if (!existingName) throw Error("remove action must have an existingName");

      return {
        operationKind: "delete_speaker",
        name: existingName,
      };
    default:
      throw Error(`unknown action ${action}`);
  }
};
